<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.yeni_sonuc_ekrani"  url="FlowCustomResultDisplays" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>


<form @submit.prevent="submitForm" class="mt-6">
<div class="grid">
<div class="col-12 md:col-12">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>
</div>
<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>

</form>


</div>
</template>
<script>
export default {

  name: 'CreateFlowCustomResultDisplay',

  data () {
    return {
	    fields:[
	      {
	        title:"İsim",
	        key:"name",
	        type:"text",
	        value:null,
	        min_length:0,
	        max_length:1000,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      ],
    }
  },
  methods:{
  	submitForm()
    {
        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false 
    },
    submit()
    {         
      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))
      console.log(formdata)  
      this.generalSubmission(formdata,"flow_custom_displays/"+this.$route.params.id,this.afterSubmit)
    },
    afterSubmit(response)
    {
        console.log(response)
        if(response.status==400)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        }
        else
        {
        	this.$router.push({ name: 'FlowCustomResultDisplay', params: { display_id:response.data.id } })
        }
      
    },

  }
}
</script>

<style lang="css" scoped>
</style>